module.exports = __webpack_public_path__ + "static/media/2.312f8a77.jpg";